import { useEffect, useState, useCallback } from "react";
import PageContainer from "../../../../components/page-container";
import Table from "../../../../components/table";
import TableReloadButton from "../../../../components/button/table-reload-button";
import Button from "../../../../components/button/button";
import Message from "../../../../components/toast-message";
import ConfirmDialog from "../../../../components/confirm-dialog/confirm-dialog";
import { getAccountUsers, deleteAccountUser } from "../../../../services/account/account-users-service";
import AddUserDialog from "./add-user-dialog";

function UsersListPage() {
  const [users, setUsers] = useState([]);
  const [formState, setFormState] = useState({
    processing: false,
    success: false,
    failed: false,
    errorMessage: "",
  });
  const [openAddUser, setOpenAddUser] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [deleteUserId, setDeleteUserId] = useState();
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false);

  const updateFormState = (processing, success, failed, errorMessage = "") => {
    setFormState({ processing, success, failed, errorMessage });
  };

  const fetchUsers = useCallback(async () => {
    updateFormState(true, false, false);
    const data = await getAccountUsers();
    setUsers(data);
    updateFormState(false, true, false);
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleUserAdded = useCallback(async () => {
    await fetchUsers();
    setOpenAddUser(false);
    setSuccessMessage("User invited successfully.");
  }, [fetchUsers]);

  useEffect(() => {
    if (!successMessage) return;
    const timer = setTimeout(() => setSuccessMessage(""), 4000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  const handleSelectDelete = (userId) => {
    setDeleteUserId(userId);
    setOpenDeleteConfirmDialog(true);
  };

  const handleConfirmDelete = async (confirmed) => {
    setOpenDeleteConfirmDialog(false);
    if (confirmed) {
      await deleteAccountUser(deleteUserId);
      setDeleteUserId();
      await fetchUsers();
      setSuccessMessage("User deleted successfully.");
    }
  };

  const processDataList = users.map((user) => ({
    record: user,
    columnsData: [
      { data: user.name, isIdField: true },
      { data: user.email },
      { data: user.role },
      {
        options: [
          {
            name: 'Update',
            onClick: () => {}
          }
        ]
      }
    ],
  }));

  return (
    <PageContainer
      title="Users"
      subtitle="Members who can access this account"
      headerAction={
        <div className="flex flex-row items-center gap-4">
          <TableReloadButton onClick={() => fetchUsers()} />
          <Button text="Add User" onClick={() => setOpenAddUser(true)} />
        </div>
      }
    >
      {successMessage && (
        <div className="mb-4">
          <Message type="success" text={successMessage} />
        </div>
      )}
      {openAddUser && (
        <AddUserDialog
          open={openAddUser}
          onCompletion={handleUserAdded}
          onCancel={() => setOpenAddUser(false)}
        />
      )}
      {openDeleteConfirmDialog && (
        <ConfirmDialog
          open={openDeleteConfirmDialog}
          onCompletion={handleConfirmDelete}
          message="Do you want to delete this user?"
        />
      )}
      <Table
        items={processDataList}
        headers={["Name", "Email", "Role"]}
        dataLoadingState={formState}
        itemsNotFoundMessage="No users found for this account"
        modifiedColumn={false}
        showActionColumn={false}
      />
    </PageContainer>
  );
}

export default UsersListPage;